import { reclaimAccessDefaultsSchema } from "@redotech/redo-model/disputes/reclaim-access-settings";
import * as z from "zod/v4";

export const updateReclaimAccessDefaults = {
  name: "updateReclaimAccessDefaults" as const,
  input: z.object({ defaults: reclaimAccessDefaultsSchema }),
  output: z.object({ defaults: reclaimAccessDefaultsSchema }),
};
